import { gql } from "@apollo/client";

export const ADD_AGENTQUOTE = gql`
  mutation AddAgentQuotes($agentQuotesVM: AgentQuotesVMInput!) {
    addAgentQuotes(agentQuotesVM: $agentQuotesVM) {
      successTypeCode
      successTypeCode
      messageDescription
      messageCode
      responseData {
        agent_id
        created_by
        created_on
        id
        is_active
        markup_value
        quote_currency
        quote_html
        quote_price
        total_price
        updated_by
        updated_on
      }
    }
  }
`;

export const ADD_MAIL_LOG = gql`
  mutation AddMailLog($mailVMInput: MailLogVMInput!) {
    addMailLog(mailLogVM: $mailVMInput) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        attachments_path
        created_by
        created_on
        form_name
        id
        mail_bcc
        mail_cc
        mail_content
        mail_from
        mail_log_id
        mail_purpose
        mail_status
        mail_subject
        mail_to
        sent_date
        updated_by
        updated_on
      }
    }
  }
`;

export const MAIL_TEMPLATE = gql`
  query MailTemplate($mailTemplateID: UUID!) {
    mailTemplate(id: $mailTemplateID) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        created_by
        created_on
        id
        is_active
        mail_bcc
        mail_cc
        mail_content
        mail_from
        mail_purpose
        mail_subject
        mail_template_id
        mail_template_name
        seq_no
        updated_by
        updated_on
      }
    }
  }
`;

export const GET_AGENTBY_ID = gql`
  query GetAgentById($id: UUID!) {
    agent(id: $id) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        address1
        agency_email
        agency_name
        approval_status
        approvedat
        approvedby
        assigned_operation_manager
        assigned_ops_team
        category
        channel
        city
        contact_person
        country_code
        designation
        email
        fax
        gst_number
        gst_state_code
        iata_number
        invoice_currency
        is_active
        lead_source
        mobile
        other_invoice_currencies
        pan
        postalcode
        preferred_currency
        previous_number
        region
        telephone
        trade_license_number
        transactional_email
        website
      }
    }
  }
`;

export const ADD_UPDATE_BOOKING_DRAFT = gql`
  mutation AddUpdateBookingDraft($bookingVMInput: String!) {
    addUpdateBookingDraft(request: $bookingVMInput) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData
    }
  }
`;

export const GET_BOOKINGDETAILS_BY_ITERNARYID = gql`
  query GetBookingDetails($itineraryId: String!) {
    bookingDetailsBasedOnItineraryId(itineraryId: $itineraryId) {
      messageDescription
      successTypeCode
      responseData {
        bid
        total_amount
        total_price
      }
    }
  }
`;
export const BOOKINGDRAFT_BY_TWBID = gql`
  query BookingDraftByTwbid($request: String!) {
    bookingDraftByTwbid(request: $request) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData
    }
  }
`;

export const GET_THRESHOLD_LIMIT = gql`
  query ThresholdLimitAdmin(
    $agent_id: UUID!
    $searchKey: String!
    $hubSearchId: String!
    $bid: String!
  ) {
    thresholdLimitAdmin(
      agent_id: $agent_id
      searchKey: $searchKey
      hubSearchId: $hubSearchId
      bid: $bid
    ) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        agent_id
        available_credit_limit
        available_threshold_limit
      }
    }
  }
`;

export const ADD_UPDATE_BOOKING_UPLOAD = gql`
  mutation AddUpdateBookingUpload($bookingUploadsVM: BookingUploadsVMInput!) {
    addUpdateBookingUpload(bookingUploadsVM: $bookingUploadsVM) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        booking_draft_id
        booking_reference_id
        created_by
        created_on
        document_name
        document_path
        document_seqno
        document_type
        id
        is_active
        product_info
        product_type
        updated_by
        updated_on
      }
    }
  }
`;

export const GET_CURRENCY_CONVERSION_RATES_QUERY = gql`
  query CurrencyConversion($searchValues: CurrencyConversionFilterVMInput!) {
    currencyConversion(searchValues: $searchValues) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        currency_value
        from_currency
        id
        to_currency
      }
    }
  }
`;
